/*
 * Purpose: User-facing product terminology — domains, brand, AutoBlocks Factory hierarchy
 * Last modified: 2026-07-10 | Agent
 * Completeness: 100
 */
import {
  CANONICAL_API_URL,
  CANONICAL_APP_URL,
  LEGACY_MARKETING_URL,
} from '@/lib/domainConfig';

/**
 * Domain split:
 * - preview.autoblocks.run — live product app (canonical)
 * - autoblocks.run / autoblocks.pro — legacy → redirect to preview
 */
export const PRODUCT_DOMAINS = {
  marketing: LEGACY_MARKETING_URL,
  app: CANONICAL_APP_URL,
  api: CANONICAL_API_URL,
} as const;

/** Canonical public URL for the product app */
export const OFFICIAL_APP_URL = PRODUCT_DOMAINS.app;

/** App wordmark / browser title */
export const PRODUCT_NAME = 'Autoblocks.run' as const;

/** Short brand for prose, placeholders, and split-flap headlines */
export const PRODUCT_BRAND = 'Autoblocks' as const;

export const PRODUCT_TERMS = {
  productName: PRODUCT_NAME,
  productBrand: PRODUCT_BRAND,
  marketingSite: PRODUCT_DOMAINS.marketing,
  appSite: PRODUCT_DOMAINS.app,
  autoBlocksFactory: 'AutoBlocks Factory',
  blockGenerator: 'Block Generator',
  blockTypes: 'Block Types',
  contextualConfiguration: 'Contextual configuration',
  brandedBlockIdeas: 'Branded block ideas',
  block: 'Block',
  blocks: 'Blocks',
  autoBlockFlow: 'AutoBlock Flow',
  autoBlockFlowComposer: 'AutoBlock Flow Composer',
  /** Running map (formerly Flow Map) — needs ≥1 block to start */
  mission: 'Mission',
  autoBlockFlowSetup: 'AutoBlock Flow Setup',
  /** Starter flows users clone into My flows */
  flowTemplates: 'Flow Templates',
  onboardingWizard: 'Onboarding Wizard',
  /** @deprecated Use mission */
  autoBlockFlowMap: 'Mission',
} as const;

/** Factory pipeline: production of Blocks and the composed flow */
export const PRODUCT_PIPELINE = [
  PRODUCT_TERMS.autoBlocksFactory,
  PRODUCT_TERMS.blockGenerator,
  PRODUCT_TERMS.blocks,
  PRODUCT_TERMS.autoBlockFlow,
] as const;

export const PRODUCT_PIPELINE_LABEL = PRODUCT_PIPELINE.join(' → ');

/** Assembly + visualization */
export const PRODUCT_EXPERIENCE_LABEL = `${PRODUCT_TERMS.autoBlockFlowComposer} assembles · ${PRODUCT_TERMS.mission} runs`;
